import {Feature, createFrontendFeature} from 'acng/core/model/feature.js';

const name = 'userPool';
export default name;
export const userPoolFeature = new Feature(name);
export const userFeature = createFrontendFeature('user');
export const guestFeature = createFrontendFeature('guest');
